module.exports = __webpack_public_path__ + "img/horse_create.b091c944.png";